import * as BABYLON from "babylonjs";
import BasicComponent from "./BasicComponent";
import MediaManager from "@/api/MediaManager";
import { Vector3 } from "babylonjs";

class ContentImageSphere extends BasicComponent {
  getType() {
    return "ImageSphere";
  }

  constructor({ id } = {}) {
    super({ id });
  }

  construct(context, prefab) {
    console.log("Construct SphereContent_ ...")
    const base = super.construct(context, prefab).getRootNode();

    
    console.log(prefab.getSphereImageID());
    const panoramaPhoto = MediaManager.getMedia(prefab.getSphereImageID());
    console.log(panoramaPhoto);

    const name = "SphereContent_" + prefab.getSphereImageID();
    const photoDome = new BABYLON.PhotoDome(
      name,
      "",
      {
        resolution: 32,
        faceForward: false,
        size: 400,
      },
      window.scene
    );
    photoDome.setEnabled(false);
    //this.disable();
    photoDome.photoTexture = panoramaPhoto.getTexture();

    if (panoramaPhoto.getAlphaIsTransparency() == "true") {
      photoDome.photoTexture.hasAlpha = true;
    }
    photoDome.parent = base;
    photoDome.mesh.isPickable = false;
    photoDome.scaling = new Vector3(0.9,0.9,0.9);

    this.photoDome = photoDome;
    

    return base;
  }
  disable(){
    super.disable();
   
  }
}

export default ContentImageSphere;
